import Box from '@material-ui/core/Box'
import { Theme } from '@material-ui/core/styles/createTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'
import React, { useContext, useEffect, useState } from 'react'

import colorContext from '../../../../Context/colorContext'
import { getImageDefault } from '../../../../services/noticias'

export interface NewsRJProps {
  categoria_titulo: string
  resumo: string
  imagem_destaque_url: string
  titulo: string
  slug: string
  autor_imagem: string
  categoria_icone: string
  categoria_slug: string
  conteudo: string
  created_at: string
  descricao_imagem: string
  descricao_video: string
  id: number
  orgao_nome: string
  orgao_sigla: string
  orgao_slug: string
  publicado: boolean
  subtopico_icone: string
  subtopico_slug: string
  subtopico_titulo: string
  tags_noticia: string
  updated_at: string
  youtube_videoId: string
}
interface Props {
  newsList: NewsRJProps[]
}

interface PropsImageDefault {
  titulo: string
  url_imagem: string
  url: string
}

export default function NewsComponent({ newsList }: Props): JSX.Element {
  const [imageDefault, setImageDefault] = useState<PropsImageDefault>()
  const { colors } = useContext(colorContext)
  const useStyles = makeStyles((theme: Theme) => ({
    main: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: colors.colorBackground,
      alignItems: 'center',
      padding: '49px 5px',
    },
    textTitle: {
      position: 'relative',
      textTransform: 'uppercase',
      fontFamily: 'Roboto',
      padding: '10px 0px 0px 3px',
      marginBottom: 5,
      fontWeight: 'bold',
      color: colors.textBody,
      left: 8,
      fontSize: theme.typography.pxToRem(36),
      '&::after': {
        content: '""',
        display: 'block',
        width: 4,
        height: 30,
        backgroundColor: colors.accentColor,
        position: 'absolute',
        bottom: 11,
        marginLeft: -14,
        left: 5,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(28),
        marginBottom: 30,
        '&::after': {
          bottom: 4,
        },
      },
    },
    card: {
      width: '100%',
      height: 374,
      borderRadius: 0,
      position: 'relative',
    },
    tagName: {
      fontSize: 13,
      textTransform: 'capitalize',
      height: 30,
      background: colors.badgeColor,
      color: colors.textAccentColor,
      fontWeight: 700,
      display: 'flex',
      alignItems: 'center',

      padding: '5px 16px',
      width: 'max-content',
      position: 'absolute',
      marginTop: -16,
    },
    tagNameCarousel: {
      fontSize: 13,
      textTransform: 'capitalize',
      height: 30,
      background: colors.badgeColor,
      color: colors.textAccentColor,
      fontWeight: 700,
      display: 'flex',
      alignItems: 'center',
      padding: '5px 16px',
      width: 'max-content',
      position: 'absolute',
      marginTop: -330,
    },
    tagDate: {
      height: 24,
      color: colors.accentColor,
      fontWeight: 500,
      display: 'flex',
      alignItems: 'center',
      paddingRight: 20,
      lineHeight: 16,
      fontSize: 14,
      width: 'max-content',
      marginTop: 33,
    },
    tagDateCarousel: {
      color: colors.textAccentColor,
      fontWeight: 400,
      display: 'flex',
      alignItems: 'center',
      paddingRight: 20,
      lineHeight: 16,
      fontSize: 18,
      position: 'absolute',
      marginTop: -370,
      marginLeft: 20,
    },
    text: {
      fontWeight: 800,
      fontSize: theme.typography.pxToRem(18),
      color: colors.textAccentColor,
    },
    textResume: {
      fontWeight: 500,
      fontSize: theme.typography.pxToRem(16),
      color: colors.textAccentColor,
      marginTop: 20,
      lineHeight: 24,
      opacity: '0.9px',
    },
    textInCarousel: {
      fontWeight: 500,
      color: colors.textAccentColor,
      position: 'absolute',
      marginTop: -200,
      marginLeft: 20,
      width: '70%',
      cursor: 'pointer',
      fontFamily: 'Roboto',
    },
    textMore: {
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(14),
      color: colors.accentColor,
      marginTop: 20,
      marginBottom: 15,
      textDecoration: 'underline',
    },
    BoxConfigMoz: {
      display: '-webkit-flex',
      flexDirection: 'column',
    },
    cardNews: {
      display: 'flex',
    },
    IconNavite: {
      color: '#0F6FB7',
      width: 44,
      height: 44,
      border: '1px solid #0F6FB7',
      borderRadius: '4px 4px 4px 4px',
      '&:hover': {
        backgroundColor: '#0F6FB7',
        color: '#fff',
      },
    },
    icon: {
      width: 24,
      height: 24,
    },
    boxNews: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      cursor: 'pointer',
      [theme.breakpoints.down('xs')]: {
        justifyContent: 'center',
      },
    },
    newSecondary: {
      margin: '0px 8px',
      display: 'flex',
      justifyContent: 'space-between',
      cursor: 'pointer',
      '@media (max-width:1054px)': {
        flexDirection: 'column',
      },
    },
    boxSecondary: {
      margin: '25px 10px 25px 10px',
    },
    legend: {
      marginTop: 5,
      marginBottom: 7,
      color: colors.colorRJWithoutGradient,
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 700,
      textTransform: 'uppercase',
      fontFamily: 'Roboto',
    },
    titulo: {
      maxWidth: 511,
      height: 83,
      fontSize: theme.typography.pxToRem(24),
      fontWeight: 700,
      color: colors.textBodyBack,
      textDecoration: 'none',
      fontFamily: 'Roboto',
    },
    button: {
      maxWidth: 360,
      width: '100%',
      marginTop: 28,
      height: 42,
      borderRadius: 25,
      backgroundColor: colors.colorWithoutGradient,
      alignSelf: 'center',
      color: colors.accentColor,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textDecoration: 'none',
      textTransform: 'uppercase',
      '&:hover': {
        backgroundColor: colors.colorWithoutGradient,
        color: '#fff',
      },
    },
    img: {
      objectFit: 'cover',
      height: 380,
      maxHeight: 'auto',
    },
    textList: {
      marginRight: 8,
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 700,
      marginLeft: 8,
      textTransform: 'uppercase',
      color: colors.accentColor,
      '&:hover': {
        color: colors.textAccentColor,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    newsPrimary: {
      maxWidth: 600,
      width: '100%',
      margin: '15px 8px',
      [theme.breakpoints.only('md')]: {
        maxWidth: '48%',
      },
      [theme.breakpoints.down('md')]: {
        width: '100%',
        maxWidth: 'initial',
      },
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
    line: {
      display: 'none',
      [theme.breakpoints.down('md')]: {
        display: 'block',
      },
    },
    box: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '20px',
      justifyContent: 'space-between',
      [theme.breakpoints.down('xs')]: {
        justifyContent: 'center',
      },
    },
    link: {
      textDecoration: 'none',
    },
  }))
  const classes = useStyles()

  useEffect(() => {
    async function handleImageDefault() {
      const { data } = await getImageDefault()
      setImageDefault(data[0])
    }

    handleImageDefault()
  }, [])

  return (
    <Box className={classes.main}>
      <Box display="flex" maxWidth="1320px" width="100%" flexDirection="column">
        <Box className={classes.box}>
          <Typography className={classes.textTitle} variant="h5" component="h2">
            Notícias
          </Typography>
        </Box>
        <Box className={classes.boxNews}>
          {newsList?.slice(0, 2).map((notice) => (
            <Box key={notice.id.toString()} className={classes.newsPrimary}>
              <a
                className={classes.link}
                href={`/noticias/${notice.slug}`}
                rel="noreferrer"
              >
                <Box
                  width="100%"
                  style={{
                    backgroundColor: !notice?.imagem_destaque_url && '#F4F6FA',
                  }}
                >
                  <img
                    width="100%"
                    height="217px"
                    src={
                      notice.imagem_destaque_url
                        ? notice.imagem_destaque_url
                        : imageDefault && imageDefault.url_imagem
                    }
                    alt={notice.titulo}
                    className={classes.img}
                    loading="lazy"
                  />
                </Box>
                <Typography className={classes.legend}>
                  {notice.subtopico_titulo}
                </Typography>
                <p className={classes.titulo}>{notice.titulo}</p>
              </a>
            </Box>
          ))}
        </Box>
        <Box className={classes.newSecondary}>
          {newsList?.slice(2, 5).map((noticeSecondary) => (
            <Box
              key={noticeSecondary.id.toString()}
              className={classes.boxSecondary}
            >
              <a
                className={classes.link}
                href={`/noticias/${noticeSecondary.slug}`}
                rel="noreferrer"
              >
                <hr className={classes.line} />
                <Typography className={classes.legend}>
                  {noticeSecondary.subtopico_titulo}
                </Typography>
                <p
                  className={classes.titulo}
                  style={{ maxWidth: 500, height: 'auto' }}
                >
                  {noticeSecondary.titulo}
                </p>
              </a>
            </Box>
          ))}
        </Box>
        <a href="/noticias" className={classes.button} rel="noreferrer">
          <p className={classes.textList}>VEJA A LISTA COMPLETA DE NOTÍCIAS</p>
        </a>
      </Box>
    </Box>
  )
}
